export default "__VITE_ASSET__GclhZq6E__"